// extracted by mini-css-extract-plugin
export default {"product_list":"product_list__bb6a390f","empty_list":"empty_list__bb6a390f"};